import { React, useEffect, useState, useLayoutEffect } from "react";
import { Card, Carousel } from "react-bootstrap";
import Heart from "react-heart";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GetAPI } from "../Utils/APIConnector";
import {
  CustomGetAPI,
  PostAPI,
  PutAPI,
  CustomPostAPI,
} from "../Utils/APIConnector";
import Loader from "../Utils/Loader";
import LazyLoadingImg from "../LazyLoading/LazyLoadingImg";
import { venueSportsData } from "../Utils/common";

export default function SavedVenues() {
  const [savedVenuesData, setSavedVenuesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isHovering, setIsHovering] = useState(null);
  const navigation = useNavigate();
  const goToVenueSearch = () => {
    navigation(-1);
  };
  useEffect(() => {
    fetchSavedVenues();
  }, []);
  const fetchSavedVenues = async () => {
    await GetAPI(`/Venue/GetSavedVenues`).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        setIsLoading(false);
        // console.log(result);
        setSavedVenuesData(result.savedVenues);
      }
    });
  };

  const handleSavedVal = async (i, flag, id, event) => {
    event.stopPropagation();
    var list = [...savedVenuesData];
    list[i]["isSaved"] = !flag;
    setSavedVenuesData(list);
    var raw = JSON.stringify(!flag);
    await PostAPI(`/Venue/ManageSavedVenue/${id}`, raw).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        if (result?.status === "Success") {
          fetchSavedVenues();
          // console.log(result);
        }
      }
    });
  };

  return (
    <>
      <div className="px-3 position-relative">
        <div className="row px-md-2">
          <div className="col-12 px-md-4">
            <img
              className=""
              src="/images/backArrow.svg"
              style={{ cursor: "pointer" }}
              onClick={goToVenueSearch}
            />
            {/* <div className="text-center">
              <span>
                <h4 className="text-center">
                  <b>Saved Venues</b>
                </h4>
              </span>
            </div> */}
          </div>
        </div>
        {isLoading ? (
          <Loader mt="10%" />
        ) : (
          <>
            {savedVenuesData?.length != 0 ? (
              <div className="row px-2 mt-3">
                {savedVenuesData?.map((venue, index) => {
                  return (
                    <>
                      <div className="col-md-4 col-12 mb-md-5 mb-4 px-md-4 px-0" key={index}>
                        <Link
                          className="text-decoration-none"
                          to={
                            `/venue-search/${venue?.address?.replaceAll(" ", "-")?.toLocaleLowerCase()}/${venue?.name
                              ?.replaceAll(" ", "-")?.toLocaleLowerCase()}`
                          }
                        >
                          <Card
                            className="cursor-pointer h-100"
                            style={{
                              borderBottom: "0px, 0px, 0.5px, 0px solid #E1E1E1",
                              borderRadius: "16px",
                              boxShadow: "0px 0px 5px 0px #0000001A",
                              position: "relative",
                              border:
                                venue?.hasPackage && venue?.diffPercentage > 0
                                  ? "2px solid #E7666A"
                                  : "1px solid #00000066",
                            }}
                          >
                            <Card.Body
                              className="py-0 px-0 d-flex flex-column"
                              onMouseEnter={() =>
                                setIsHovering((prev) => {
                                  return prev ? prev : index;
                                })
                              }
                              onMouseLeave={() => setIsHovering(null)}
                            >
                              <div className="venueImages position-relative mb-3">
                                {venue?.hasPackage && venue?.diffPercentage > 0 && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "-1px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      zIndex: 1,
                                      color: "white",
                                      background: "#E7666A",
                                      textAlign: "center",
                                      width: "max-content",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      borderBottomLeftRadius: "5px",
                                      borderBottomRightRadius: "5px",
                                      padding: "8px 15px",
                                    }}
                                  >
                                    Special Package Deal{" "}
                                    <b>({venue?.diffPercentage.toFixed(0)}% OFF)</b>
                                  </div>
                                )}

                                {venue?.hasOffers && (
                                  <img
                                    src="/images/specialoffer.svg"
                                    className="img-fluid"
                                    alt="Special Offer"
                                    style={{
                                      position: "absolute",
                                      bottom: "10px",
                                      right: "10px",
                                      zIndex: 1,
                                      maxWidth: "100px",
                                    }}
                                  />
                                )}

                                {venue?.isFeatured && (
                                  <img
                                    src="/images/CbFeatured.svg"
                                    className="img-fluid"
                                    alt="Featured"
                                    style={{
                                      position: "absolute",
                                      bottom: "10px",
                                      left: "1px",
                                      zIndex: 1,
                                      maxWidth: "100px",
                                    }}
                                  />
                                )}

                                <div className="row position-relative" style={{ padding: "0 12px" }}>
                                  <div className="col-12 px-0">
                                    <button
                                      className="saveVenueButton d-flex align-items-center"
                                      style={{ right: "6%", top: "2%", bottom: "auto" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleSavedVal(index,
                                          venue?.isSaved,
                                          venue?.id,
                                          e
                                        );
                                      }}
                                    >
                                      <img
                                        src={`/images/${venue?.isSaved ? "heart_filled" : "heart_empty"}.svg`}
                                        alt=""
                                        className="cursor-pointer"
                                        style={{ width: "26px", height: "26px" }}
                                      />
                                    </button>
                                    <Carousel
                                      controls={false}
                                      interval={isHovering === index ? 3000 : null}
                                      indicators={true}
                                    >
                                      {venue?.venueImages?.map((data, i) => (
                                        <Carousel.Item className="Carousel-radius" key={i}>
                                          <LazyLoadingImg
                                            src={data}
                                            alt="image"
                                            title=""
                                            className="venuePhotos w-100"
                                          />
                                        </Carousel.Item>
                                      ))}
                                    </Carousel>
                                  </div>
                                </div>
                              </div>

                              <div className="cursor-pointer">
                                <div className="row mx-0 mt-1">
                                  <div className="col-md-6 col-7 pe-0">
                                    <h2
                                      className="Montserrat fw-semibold m-0"
                                      style={{ color: "black", fontSize: "16px" }}
                                    >
                                      {venue?.name}
                                    </h2>
                                  </div>
                                  <div className="col-md-6 col-5 ps-0 text-end">
                                    <div className="text-end">
                                      {venue?.venueSports?.map((data, i) => (
                                        <>
                                          {i < 2 && (
                                            <div className="sportimage ms-2">
                                              <img
                                                src={`/images/${venueSportsData(data?.name)}`}
                                                className="img-fluid"
                                                alt={data?.name}
                                                title={data?.name}
                                                style={{
                                                  borderRadius: "11px",
                                                  padding: "3px",
                                                  height: "30px",
                                                  width: "30px",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {i === 2 && venue?.venueSports?.length > 2 && (
                                            <div
                                              className="mx-lg-1 mx-1 Montserrat"
                                              style={{ fontSize: "14px" }}
                                            >
                                              + {venue?.venueSports?.length - 2} more
                                            </div>
                                          )}
                                        </>
                                      ))}
                                      {venue?.venueSports?.length === 0 && (
                                        <span className="venueText">No sports available</span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <p
                                      className="Montserrat"
                                      style={{
                                        color: "#5c5c5c",
                                        fontSize: "14px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {venue?.address}{" "}
                                      {venue?.distanceInKm?.toFixed(1) > 0.0 &&
                                        `(~${venue?.distanceInKm?.toFixed(1)} km)`}
                                    </p>
                                  </div>
                                </div>
                                {/* <div className="row align-items-center mx-0 mb-3">
                                  <div className="col-6">
                                    <div className="venuePriceDetails">
                                      <span className="text-black fw-bold">
                                        ₹{venue?.averagePrice}
                                      </span>
                                      <span className="">&nbsp;onwards</span>
                                    </div>
                                  </div>
                                  {[4, 5, 6].includes(venue?.isAcrive) && (
                                    <div className="col-md-6 col-6 text-end h-100">
                                      <button className="venueListingBooknow">
                                        Book Now
                                        <img
                                          src="/images/white-arrow.svg"
                                          alt="arrow"
                                          className="mx-1"
                                        />
                                      </button>
                                    </div>
                                  )}
                                </div> */}
                              </div>
                            </Card.Body>
                          </Card>
                        </Link>
                      </div>
                      {/* <div className="venueCard">
                        <Card
                          className="mt-3"
                          style={{
                            borderRadius: "16px",
                            background: "white",
                            border: "none",
                            boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
                          }}
                          onClick={() => {
                            handleVenuePlace(data?.id);
                          }}
                        >
                          <Card.Body>
                            <div className="row">
                              <div className="col-4 display-center">
                                <div className="col-12 px-0" >
                                  <img
                                    src={data?.venueImages?.[0]}
                                    className="venuePhotos w-100"
                                    style={{ height: '100px', borderRadius: '16px' }}
                                    alt="image"
                                  />
                                </div>
                              </div>
                              <div className="col-8">
                                <div className="row">
                                  <div className="col-8">
                                    <span className="venueName cursorClass text-decoration-underline">
                                      {data?.name}
                                    </span>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      className="venueIcons text-end"
                                      style={{ position: "relative" }}
                                    >
                                      {data?.isSaved === true ? (
                                        <img
                                          src="/images/heart_filled.svg"
                                          onClick={(e) =>
                                            handleSavedVal(
                                              index,
                                              data?.isSaved,
                                              data?.id,
                                              e
                                            )
                                          }
                                        />
                                      ) : (
                                        <img
                                          src="/images/heart_empty.svg"
                                          onClick={(e) =>
                                            handleSavedVal(
                                              index,
                                              data?.isSaved,
                                              data?.id,
                                              e
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-10">
                                    <span className="venueRate">
                                      Address:{" "}
                                      <span className="">{data?.address}</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </div> */}
                    </>
                  );
                })}
              </div>
            ) : (
              <>
                <div
                  className="citiesbox border-0 text-center"
                  style={{ background: "transparent" }}
                >
                  No Saved Venues Found
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
}
